import * as API_CONSTANT from "../constants";

export const getAllEmployee = () =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({}),
  }).then((res) => res.json());

export const getAllEmployeeInfoByCoid = ({coid}) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/get/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({coid}),
  }).then((res) => res.json());

export const createEmployee = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/create`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const updateEmployee = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const validateBulkEmployee = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/bulk/validate`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const bulkUploadEmployee = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employee/bulk/upload`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
